import * as React from "react";
import { DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { SheetTitle, SheetDescription } from "@/components/ui/sheet";

type ModalHeaderProps = {
  title: string;
  description?: string;
  headerStart?: React.ReactNode;
  isSheet?: boolean;
};

export const ModalHeader = ({
  title,
  description,
  headerStart,
  isSheet = false,
}: ModalHeaderProps) => {
  const TitleComp = isSheet ? SheetTitle : DialogTitle;
  const DescComp = isSheet ? SheetDescription : DialogDescription;

  if (isSheet) {
    return (
      <div className="px-4 py-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex min-w-0 flex-1 items-start gap-3">
            {headerStart ? (
              <div className="shrink-0 pt-0.5">{headerStart}</div>
            ) : null}
            <div className="min-w-0">
              <TitleComp className="text-[22px] font-semibold tracking-[-0.02em] text-[#1C1E21] sm:text-2xl">
                {title}
              </TitleComp>
              {description ? (
                <DescComp className="whitespace-nowrap text-sm leading-5 text-[#898D91] sm:text-[15px] sm:leading-[22px]">
                  {description}
                </DescComp>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6 p-6 pb-0 text-left">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-3">
          {headerStart ? <div className="shrink-0">{headerStart}</div> : null}
          <TitleComp className="text-2xl font-semibold text-gray-900">
            {title}
          </TitleComp>
        </div>

        {description ? (
          <DescComp className="text-base text-gray-500">{description}</DescComp>
        ) : null}
      </div>
    </div>
  );
};
